// import React from 'react'
// let user = JSON.parse(localStorage.getItem('user'));
// let empInfo = user && user.empInfo;
const contant_ = '测试环境'

// if (empInfo && empInfo.name && empInfo.workNumber) {
//   contant_ = `数字营销云-${empInfo.name}(${empInfo.workNumber})`;
// }
const waterMark = {
  txtwatermark: ({
    container = document.body, //容器
    width = `${document.body.offsetWidth}px`, //水印的大小
    height = `${document.body.offsetHeight}px`,
    textAlign = 'center', //文字对齐
    textBaseline = 'middle', //基准线
    font = '320 16px Microsoft Yahei', //字体大小及样式
    fillStyle = 'rgba(0, 0, 0, 0.06)', //自定义水印的颜色以及透明度
    content = contant_, //内容
    rotate = '-25', //文字旋转角度
    zIndex = 1000, //元素堆叠顺序，-1是在最下面
  } = {}) => {
    const args = arguments[0]
    const canvas = document.createElement('canvas')
    //HTML5 <canvas> 元素用于图形的绘制，通过脚本 (通常是JavaScript)来完成
    canvas.setAttribute('width', width)
    canvas.setAttribute('height', height)
    const ctx = canvas.getContext('2d') //当前唯一的合法值是 "2d"，它指定了二维绘图

    ctx.textAlign = textAlign
    ctx.textBaseline = textBaseline
    ctx.font = font
    ctx.fillStyle = fillStyle
    ctx.rotate((Math.PI / 180) * rotate)
    // ctx.fillText(content, parseFloat(width) / 4, parseFloat(height) / 2);
    // ctx.fillText('dsafsf', parseFloat(width) / 4, parseFloat(height) / 3);//换行
    // 动态改变字体大小
    // if(ctx.measureText(content).width > 180) {
    //     let size = 180 / content.length;
    //     ctx.font = '800 ' + size +'px '+ ' Microsoft JhengHei'
    // }
    const disX = content.length * 18 < 200 ? 200 : content.length * 18
    for (let i = document.body.offsetHeight * 10 * -1; i < document.body.offsetWidth; i += disX) {
      for (let j = 0; j < document.body.offsetHeight * 10; j += 180) {
        // Y 轴间距
        // 填充文字，x 间距, y 间距
        ctx.fillText(content, i, j)
      }
    }
    const base64Url = canvas.toDataURL()
    //返回一个包含图片展示的 data URI 。可以使用 type 参数其类型，默认为 PNG 格式。
    const __wm = document.querySelector('.__wm') //选择器

    const watermarkDiv = __wm || document.createElement('div')
    const styleStr = `
            position:absolute;
            top:60px;
            left:200px;
            width:100%;
            height:100%;
            z-index:${zIndex};
            pointer-events:none;
            background-repeat:no-repeat;
            background-image:url('${base64Url}')`
    watermarkDiv.setAttribute('style', styleStr)
    watermarkDiv.classList.add('__wm') //在元素中添加类名，可以加载CSS样式

    if (!__wm) {
      // container.style.position = 'relative'
      // container.insertBefore(watermarkDiv, container.firstChild) //添加元素
    }
    const MutationObserver = window.MutationObserver || window.WebKitMutationObserver
    //检查浏览器是否支持这个API
    if (MutationObserver) {
      let mo = new MutationObserver(function () {
        const __wm = document.querySelector('.__wm')
        // 只在__wm元素变动才重新调用 __canvasWM
        if ((__wm && __wm.getAttribute('style') !== styleStr) || !__wm) {
          // 避免一直触发
          mo.disconnect()
          mo = null
          index.txtwatermark(JSON.parse(JSON.stringify(args)))
        }
      })

      mo.observe(container, {
        attributes: true, //观察目标节点的属性节点
        subtree: false, //观察目标节点的所有后代节点
        childList: false, //观察目标节点的子节点
      })
    }
  },
  picWaterMark: ({
    url = '',
    textAlign = 'center',
    textBaseline = 'middle',
    font = '20px Microsoft Yahei',
    fillStyle = 'rgba(255, 255, 255, 0.8)',
    content = '请勿外传',
    cb = null,
    textX = 500,
    textY = 500,
  } = {}) => {
    const img = new Image()
    img.src = url
    img.crossOrigin = 'anonymous'
    img.onload = function () {
      const canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      const ctx = canvas.getContext('2d')

      ctx.drawImage(img, 0, 0)
      ctx.textAlign = textAlign
      ctx.textBaseline = textBaseline
      ctx.font = font
      ctx.fillStyle = fillStyle
      ctx.fillText(content, img.width - textX, img.height - textY)
      const base64Url = canvas.toDataURL()
      cb && cb(base64Url)
    }
  },
}
export default waterMark
